import React, { useEffect, useRef, useState } from 'react';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { Tooltip } from '@mui/material';

import {
  ArrowContainer,
  BannerContainer,
  BannerContent,
  BannerImage,
  BannerSubtitle,
  BannerTitle,
} from './styles';
import { AgreNordBannerProps } from './types';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-expect-error
import agreNordBanner from '../../../../assets/images/arge-nord-banner.png';
import { TranslationKeys } from '../../../../i18n/locales/defaultResources';
import { useI18n } from '../../../../hooks/useI18n';

const ArgeNordBanner: React.FC<AgreNordBannerProps> = ({ onClick }) => {
  const { t } = useI18n();
  const subtitleRef = useRef<HTMLDivElement>(null);
  const [showTooltip, setShowTooltip] = useState(false);

  useEffect(() => {
    const checkOverflow = () => {
      if (subtitleRef.current) {
        const isOverflowing =
          subtitleRef.current.scrollHeight > subtitleRef.current.clientHeight;
        setShowTooltip(isOverflowing);
      }
    };

    checkOverflow();
    window.addEventListener('resize', checkOverflow);

    return () => {
      window.removeEventListener('resize', checkOverflow);
    };
  }, [t(TranslationKeys.agrenordbanner_subtitle)]);

  const subtitleContent = t(TranslationKeys.agrenordbanner_subtitle);
  const subtitleElement = showTooltip ? (
    <Tooltip
      title={subtitleContent}
      arrow
      PopperProps={{
        modifiers: [
          {
            name: 'offset',
            options: {
              offset: [0, -8],
            },
          },
        ],
      }}
    >
      <BannerSubtitle ref={subtitleRef}>{subtitleContent}</BannerSubtitle>
    </Tooltip>
  ) : (
    <BannerSubtitle ref={subtitleRef}>{subtitleContent}</BannerSubtitle>
  );

  return (
    <BannerContainer onClick={onClick}>
      <BannerImage
        src={agreNordBanner}
        alt={t(TranslationKeys.agrenordbanner_alt) as string}
      />
      <BannerContent>
        <BannerTitle>{t(TranslationKeys.agrenordbanner_title)}</BannerTitle>
        {subtitleElement}
      </BannerContent>
      <ArrowContainer>
        <ChevronRightIcon />
      </ArrowContainer>
    </BannerContainer>
  );
};

export default ArgeNordBanner;
